// https://github.com/garmeeh/next-seo/blob/master/src/utils/markup.tsx
export const markup = (
  raw: string
): {
  __html: string
} => ({ __html: raw })
